import React, { Fragment } from 'react'
import AntDesign from 'styles/extra/ant-design'

export default () => (
  <Fragment>
    <AntDesign />
  </Fragment>
)
